// CHANGE THE ENDPOINT FOR TARGET ENV
export const baseURL = process.env.NEXT_PUBLIC_API_BASE_URL
  ? process.env.NEXT_PUBLIC_API_BASE_URL
  : "https://staging-my-api.hiredly.com";
export const assetDomain = "https://assets.wobbjobs.com";
export const strapiBaseURL = process.env.STRAPI_API_URL
  ? process.env.STRAPI_API_URL
  : "http://localhost:1337/graphql";
